let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("hI5Pk"), load("cMKIL")]).then(() => parcelRequire('kKFb3'));